import React from "react";

import "./config";
import { useTranslation } from "react-i18next";
const Translate = (props: any) => {
	const { t } = useTranslation();

	return <>{t(props.text)}</>;
};

export default Translate;
